<mat-card (click)="occupationClick.emit(occupation)">
  <section class="grid-y">
    <!-- IMAGE -->
    <div class="image-container">
      <img alt="" class="image" mat-card-avatar [src]="imageUrl" />
      <h2 class="name">{{ occupation.title }}</h2>
      <div class="bookmark-button">
        <cpd-occupation-favorite-button
          [onetCode]="occupation.onetCode"
          [jobId]="occupation.jobId"
        >
        </cpd-occupation-favorite-button>
      </div>
      <div class="gradient-overlay"></div>
    </div>

    <!-- STUFF -->
    <div
      class="grid-x info-container flex-child-auto relative justify-between align-bottom"
    >
      <section class="grid-y grid-padding-y content-container">
        <!-- NAME -->
        <div class="badges grid-x align-middle">
          <span class="statValue">
            {{ occupation.typicalEducationLevelGroup }}
          </span>
        </div>
        <div class="salary grid-x align-middle">
          <!-- numberSuffix renders null as empty, leaving a bare "/ Year" -->
          <div
            *ngIf="occupation.medianAnnualWage != null"
            class="badges grid-x align-middle"
          >
            <span class="statValue">
              {{ occupation.medianAnnualWage | numberSuffix: true }}
            </span>
            <span class="statLabel">/ Year</span>
          </div>

          <div class="badges grid-x align-middle">
            <span class="statValue"> {{ occupation.growthRateBand }}</span>
            <span class="statLabel">growth</span>
          </div>
        </div>
      </section>
      <section class="chart">
        <!-- MATCHES -->
        <cpd-occupation-scores-display
          class="occupation-card"
          [occupation]="occupation"
        >
        </cpd-occupation-scores-display>
      </section>
    </div>
  </section>
</mat-card>
